import { CheckboxMarkedCircleAutoOutlineIcon } from './CheckboxMarkedCircleAutoOutlineIcon';

/**
 * author: Jeff Anders
 * id F55DDDD9-41D3-477B-A513-DD6CF2487E0B
 * name checkbox-marked-circle-auto-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-marked-circle-auto-outline.svg
 * tags
 * - Form 
 */
export const TaskAutoIcon = CheckboxMarkedCircleAutoOutlineIcon;
export default TaskAutoIcon